import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { getSingleTspType, TspPageDenomination, TspPagePayee, TspType } from '@entities/tsp';
import { Text } from '@shared/ui/atoms';
import { ICON_TCP } from '@shared/config';
import { withTheme } from '@shared/lib/theme';
import { parseDenominationAmount } from '../lib/parseDenominationAmount';
interface DenominationOrderCardProps {
  payee: TspPagePayee;
  denomination: TspPageDenomination | null;
}
const DenominationOrderCard: FC<DenominationOrderCardProps> = ({
  payee,
  denomination
}) => {
  const type = getSingleTspType(payee);
  const {
    baseAmount,
    bonusAmount
  } = parseDenominationAmount(denomination?.features?.buttonLabel as string);
  return <DenominationOrderCardWrapper>
      <ImageWrapper type={type}>
        <Image src={type === TspType.KEYS ? `${ICON_TCP}${payee.icon}` : `${ICON_TCP}${denomination?.features?.iconsubcategory}`} alt="order denomination" width={52} height={52} />
      </ImageWrapper>
      <TextWrapper>
        <Text family="MTSCompact" weight="medium" size={{
        desktop: 'pL',
        mobile: 'pM'
      }} color="primary">
          {baseAmount ? `${baseAmount} ${bonusAmount ? `+ ${bonusAmount}` : ''}` : denomination?.features?.buttonLabel}
        </Text>
      </TextWrapper>
    </DenominationOrderCardWrapper>;
};
export default DenominationOrderCard;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.tertiary;
const DenominationOrderCardWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "DenominationOrderCardWrapper",
  class: "dyntlw8",
  propsAsIs: false,
  vars: {
    "dyntlw8-0": [_exp()]
  }
}));
interface ImageWrapperProps {
  type: TspType | undefined;
}
const _exp2 = /*#__PURE__*/() => ({
  type
}) => type === TspType.KEYS ? '0.5rem' : '0';
const _exp3 = /*#__PURE__*/() => ({
  type
}) => type === TspType.KEYS ? 'hidden' : 'visible';
const _exp4 = /*#__PURE__*/() => ({
  type
}) => type === TspType.KEYS ? '8px' : '0';
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "irco07z",
  propsAsIs: false,
  vars: {
    "irco07z-0": [_exp2()],
    "irco07z-1": [_exp3()],
    "irco07z-2": [_exp4()]
  }
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tycxcbb",
  propsAsIs: false
});

require("./DenominationOrderCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DenominationOrderCard.tsx");